import React, { useState } from "react";
import { useLanguage } from "../contexts/LanguageContext";
import { useTranslations } from "../translations";
import "./SearchBar.css";

interface SearchBarProps {
  onSearch: (query: string) => void;
}

const SearchBar: React.FC<SearchBarProps> = ({ onSearch }) => {
  const [query, setQuery] = useState("");
  const { language } = useLanguage();
  const t = useTranslations(language);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (query.trim()) {
      onSearch(query.trim());
    }
  };

  return (
    <div className="search-bar-container">
      <form onSubmit={handleSubmit} className="search-bar">
        <input
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder={t.searchPlaceholder}
          className="search-input"
          autoFocus
        />
        <button type="submit" className="search-button">
          {t.searchButton}
        </button>
      </form>
      <p className="search-help-text">{t.searchHelpText}</p>
    </div>
  );
};

export default SearchBar;
